import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from '@/core/services/open-api/api.service';
import { HttpClient } from '@angular/common/http';
import { Layer } from '@/core/models/layer';
import { CloneUtils } from '@/core/utils/clone-utils';

/**
 * @class LayerRepository
 * @description Encapsulates raw API communication for layers.
 */
@Injectable({ providedIn: 'root' })
export class LayerRepository extends ApiService {
    constructor(http: HttpClient) {
        super(http);
    }

    public getAll(): Observable<Layer[]> {
        return this._http.get<Layer[]>(ApiService.openApiUrl + 'layers').pipe(
            map((layers) => {
                // change layer with name as empty string to layer with default name as 'Layer' + index
                layers.forEach((layer) => {
                    if (layer.name?.trim() === '') {
                        layer.name = `Layer ${layer.index}`;
                    }
                });
                return layers.sort((n1, n2) => (n1.index ?? 0) - (n2.index ?? 0));
            }),
        );
    }

    public create(layer: Layer): Observable<void> {
        return this._http.post<void>(ApiService.openApiUrl + 'layers', layer);
    }

    public createIndexLayer(layer: Layer): Observable<void> {
        // Note: Clone the object before deleting the index property. The parameter object should not be modified.
        const layerCopy = CloneUtils.cloneData(layer);
        const index = layerCopy.index;
        delete layerCopy.index;
        return this._http.post<void>(ApiService.openApiUrl + 'layers/' + index, layerCopy);
    }

    public update(layer: Layer): Observable<void> {
        return this._http.put<void>(ApiService.openApiUrl + 'layers/' + layer.id, layer);
    }
}
